import "./Home.scss";
import About from "../../components/About/About";
import WhyTotem from "../../components/WhyTotem/WhyTotem";
import Download from "../../components/Download/Download";
import Hero from "../../components/Hero/Hero";
import Connect from "../../components/Connect/Connect";
import textData from "../../utils/langText";
import MetaDecorator from "../../components/MetaDecorator";
import img from '../../assets/about-card-1.webp'

const Home = () => {
  return (
    <>
    <MetaDecorator title="Totem" desc="TotemChat" imageUrl={img} url="https://thetotemchat.com/" />
    <main className="home">
      <Hero textData={textData} />
      <Connect textData={textData} />
      <About textData={textData} />
      <WhyTotem textData={textData} />
      <Download textData={textData} />
    </main>
    </>
  );
};

export default Home;
